module.exports = __webpack_public_path__ + "img/sld_abt_meter_t1_b1_disable.6a373359.svg";